import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto flex justify-between items-center px-4 font-bold" }
const _hoisted_2 = { class: "hidden md:flex space-x-4" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "flex flex-col space-y-4" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_MenuOutlined = _resolveComponent("MenuOutlined")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["bg-gradient-to-br from-blue-600 to-gray-600 text-white shadow-md", {
      'bg-gradient-to-br from-blue-500 to-gray-600':
        _ctx.$route.meta?.name === 'Direc',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo text-xl font-bold hover:text-gray-400 py-4 tracking-in-expand"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.i18n.global.t("PROJECT.NAME")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "hover:text-gray-400 py-4",
          "exact-active-class": "border-b-2 border-white font-bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.HOME_LINK")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/l/english",
          class: "hover:text-gray-400 py-4",
          "active-class": "border-b-2 border-white",
          "exact-active-class": "border-b-2 border-white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.i18n.global.t(
              "NAVIGATION_MENU.LANGUAGE_LEARNING_SECTION.ENGLISH_SUBMENU.DESCRIPTION"
            )), 1)
          ]),
          _: 1
        }),
        (_ctx.user)
          ? (_openBlock(), _createBlock(_component_a_dropdown, {
              key: 0,
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      key: "0",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'AccountOverview' })))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_anchor_link, {
                          title: _ctx.user?.email,
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_UserOutlined),
                              _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t(
                        "NAVIGATION_MENU.ACCOUNT_DROPDOWN.INFORMATION_PROFILE"
                      )), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_divider),
                    _createVNode(_component_a_menu_item, {
                      key: "1",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/c/setting')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_anchor_link, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_SettingOutlined),
                              _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.SETTING_PAGE.DESCRIPTION")), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, {
                      key: "2",
                      class: "hover:text-gray-400 flex items-center",
                      onClick: _ctx.logout
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_anchor_link, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_LogoutOutlined),
                              _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.LOGOUT_LINK")), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: _normalizeClass([
              _ctx.$route.path.includes('account')
                ? 'border-b-2 border-gray-100 font-bold'
                : ''
            , "ant-dropdown-link flex items-center py-4 hover:text-gray-400 hover:border-b-2 border-white hover:cursor-pointer"])
                }, [
                  _createVNode(_component_UserOutlined, { class: "" }),
                  _createTextVNode("   " + _toDisplayString(_ctx.user.username), 1)
                ], 2)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.user)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/c/login",
              class: "hover:text-gray-400 py-4",
              "active-class": "text-white",
              "exact-active-class": "border-b-2 border-white"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.LOGIN_LINK")) + " / " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.REGISTER_LINK")), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_MenuOutlined, {
        class: "text-white text-2xl md:hidden flex items-center",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDrawer = true))
      })
    ]),
    _createVNode(_component_a_drawer, {
      placement: "right",
      closable: "",
      visible: _ctx.showDrawer,
      onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDrawer = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_6, [
          (_ctx.user)
            ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, {
                        key: "0",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'MobileInfoLayout' })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, {
                            class: "hover:text-gray-400",
                            title: _ctx.user?.email
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_UserOutlined),
                                _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t(
                        "NAVIGATION_MENU.ACCOUNT_DROPDOWN.INFORMATION_PROFILE"
                      )), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["title"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_divider),
                      _createVNode(_component_a_menu_item, {
                        key: "1",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/c/setting')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_SettingOutlined),
                                _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.SETTING_PAGE.DESCRIPTION")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "2",
                        class: "hover:text-gray-400 flex items-center",
                        onClick: _ctx.logout
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_anchor_link, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_LogoutOutlined),
                                _createTextVNode("   " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.LOGOUT_LINK")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "ant-dropdown-link flex items-center py-4 hover:text-gray-400 border-b-2 border-white-700",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createVNode(_component_UserOutlined),
                    _createTextVNode("   " + _toDisplayString(_ctx.user.username), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.user)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDrawer = false)),
                to: "/c/login",
                class: "hover:text-gray-400 py-4",
                "active-class": "text-blue-500",
                "exact-active-class": "border-b-2 border-white-700"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.LOGIN_LINK")) + " / " + _toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.REGISTER_LINK")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDrawer = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n.global.t("NAVIGATION_MENU.HOME_LINK")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/l/english/tab=mobile",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDrawer = false)),
            "active-class": "border-l-4 pl-2 border-blue-500",
            "exact-active-class": "border-l-4 pl-2  border-white-700"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.i18n.global.t(
              "NAVIGATION_MENU.LANGUAGE_LEARNING_SECTION.ENGLISH_SUBMENU.DESCRIPTION"
            )), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}